<template>
   <div>
      <p class="archive-text">年数を選択ください。選択した年のMFJライディングが表示されます。<br>（1963年の創刊から2012年まで協会が発行していた機関誌全刊をご覧いただけます。）</p>
      <p class="archive-select"><input v-model="selectYear" type="number" min="1963" max="2012" />年</p>
      <section class="archive-show">
         <h2 class="archive-show__title"><svg class="icon icon-mfj-riding"><use xlink:href="#icon-mfj-riding"></use></svg>{{ selectYear }}</h2>
         <ul v-html="getYear()" class="archive-show__items"></ul>
         <p>※本サイト内のMFJライディング誌を含む、写真、画像、文章、その他すべてのコンテンツは、MFJの許可なく転載、二次使用することを禁止します。</p>
      </section>
  </div> 
</template>

<script>
import items from '@/assets/data.json'
export default {
   data: function() {
      return {
         selectYear: '1963'
      }
   },
   methods: {
      getYear: function () {
         var result = '',
            selected = this.selectYear
         items.forEach(function(item) {
            if(item.year == selected){
               var src = item.year+'_'+item.no+'_'+item.global;
               result += '<li><a target="_blank" href="../pdfviewer/web/viewer.html?file=/pdf/'+src+'.pdf"><img src="/cover/'+item.year+'/'+src+'.jpg" width="120" height="175"></a></li>';
            }
            
         });
         return result;
      }
  }
}
</script>

<style lang="scss">
.archive-text{
   text-align: center;
   margin-top: 145px;
}
.archive-select {
   text-align: center;
   font-size: 40px;
   input[type="number"] {
      font-family: 'Barlow Condensed', sans-serif;
      font-size: 60px;
      width: 215px;
      text-align: center;
      margin-right: 10px;
      letter-spacing: 5px;
   }
}
.archive-show{
   padding: 20px;
   background: #ffffff;
   margin-left: 45px;
   margin-right: 60px;
   margin-bottom: 60px;
   &__title{
      display: flex;
      margin-left: 5px;
      .icon{
         margin-right: 10px;
         margin-left: 0;
      }
   }
   &__items{
      list-style: none;
      display: flex;
      padding: 0;
      flex-wrap: wrap;
      li{
         margin-left: 5px;
         margin-right: 5px;
      }
   }
}
@media(max-width:767px){
   .archive-text{
      text-align: left;
      padding: 0 20px;
   }
   .archive-show{
      margin: 0 20px 40px;
      &__items{
         li{
            margin: 0 10px 15px;
         }
         img{
            width: 72px;
         }
      }
   }
}
</style>